import { render, staticRenderFns } from "./dataAuthority.vue?vue&type=template&id=dfaba6e8"
import script from "./dataAuthority.vue?vue&type=script&lang=js"
export * from "./dataAuthority.vue?vue&type=script&lang=js"
import style0 from "./dataAuthority.vue?vue&type=style&index=0&id=dfaba6e8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfaba6e8')) {
      api.createRecord('dfaba6e8', component.options)
    } else {
      api.reload('dfaba6e8', component.options)
    }
    module.hot.accept("./dataAuthority.vue?vue&type=template&id=dfaba6e8", function () {
      api.rerender('dfaba6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/roleManage/dataAuthority.vue"
export default component.exports